import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from '@mysvg/page-not-found/components/page-not-found/page-not-found.component';
import { PageNotFoundModule } from '@mysvg/page-not-found/page-not-found.module';
import { ErrorPageComponent } from '@svg-frontends/error/components/error-page/error-page.component';
import { NewReleaseChunkErrorPageComponent } from '@svg-frontends/error/components/new-release-chunk-error-page/new-release-chunk-error-page.component';
import { ErrorModule } from '@svg-frontends/error/error.module';
import { PageLogoutComponent } from '@svg-frontends/page-logout/page-logout/page-logout.component';
import { InitialAuthenticationGuard } from '@svg-frontends/session/authentication/guards/initial-authentication.guard';
import { IsNotLoggedInGuard } from '@svg-frontends/session/authentication/guards/is-not-logged-in.guard';

const ROUTES: Routes = [
	{
		path: 'public',
		canActivate: [IsNotLoggedInGuard],
		loadChildren: () => import('./feature/public-base/public-base.module').then((module) => module.PublicBaseModule),
	},
	{ path: 'error', component: ErrorPageComponent },
	{ path: 'update-error', component: NewReleaseChunkErrorPageComponent },
	{ path: 'logout', component: PageLogoutComponent },
	{ path: 'login', redirectTo: '', pathMatch: 'full' },
	{
		canActivate: [InitialAuthenticationGuard],
		loadChildren: () => import('./feature/app-base/app-base.module').then((module) => module.AppBaseModule),
		path: '',
	},
	{ path: '**', component: PageNotFoundComponent },
];

@NgModule({
	exports: [RouterModule],
	imports: [
		ErrorModule,
		PageNotFoundModule,
		RouterModule.forRoot(ROUTES, {
			// `anchorScrolling` needs to be disabled for oauth implicit flow
			anchorScrolling: 'disabled',
			bindToComponentInputs: true,
			preloadingStrategy: NoPreloading,
			scrollPositionRestoration: 'enabled',
			// `urlUpdateStrategy` default is `deferred`, but eager is needed for clean url after login via oauth2
			urlUpdateStrategy: 'eager',
			// enableTracing: true,
		}),
	],
})
export class AppRoutingModule {}
